import { CommonTagIconProps } from '../types';

const NumberOfScenes11OrMore = ({ dimension }: CommonTagIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 24"
    fill="none"
    stroke="#101828"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width={dimension || 20}
    height={dimension || 20}
  >
    <rect x="1" y="2" width="32" height="20" rx="2" ry="2" />
    <rect x="4" y="5" width="4" height="14" />
    <rect x="10" y="5" width="4" height="14" />
    <rect x="16" y="5" width="4" height="14" />
    <text x="30" y="19" font-size="10" font-weight="bold" text-anchor="end">
      +
    </text>
  </svg>
);
export default NumberOfScenes11OrMore;
